import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";

export const selectCurrentPlan = createSelector(
  (state: RootState) => state.pricingPlans.data,
  (state: RootState) => state.user.user,
  (plans, user) => plans?.find((plan) => plan.planId === user?.planDetails?.planId),
);

// export const selectIsFreePlan = createSelector(
//   (state: RootState) => state.pricingPlans.data,
//   (state: RootState) => state.user.user,
//   (plans, user) => {
//     const currentPlan = plans?.find(
//       (plan) => plan.id === user?.planDetails?.planId,
//     );
//     if (currentPlan?.name.toLowerCase() === "free") {
//       return true;
//     } else {
//       return false;
//     }
//   },
// );

export const selectGrowthMonthlyPlan = createSelector(
  (state: RootState) => state.pricingPlans.data,
  (plans) =>
    plans.find(
      (plan) =>
        plan.planId === "growth_monthly" ||
        (plan.name.toLowerCase() === "growth" && plan.period === "monthly"),
    ),
);

export const selectGrowthYealyPlan = createSelector(
  (state: RootState) => state.pricingPlans.data,
  (plans) =>
    plans.find(
      (plan) =>
        plan.planId === "growth_annually" ||
        (plan.name.toLowerCase() === "growth" && plan.period !== "monthly"),
    ),
);